const JSON_KEY_ID = "id";
const JSON_KEY_LIMIT_INCREASE_ID = "limit-increase-id";
const JSON_KEY_DOCUMENT_TYPE = "document-type";
const JSON_KEY_DOCUMENT_TYPE_DISPLAY = "document-type-display";
const JSON_KEY_META_DATA_ID = "meta-data-id";


export default class LimitIncreaseAddressDocument {

    constructor(jsonResponse) {

        this.id = jsonResponse[JSON_KEY_ID];
        this.limitIncreaseId = jsonResponse[JSON_KEY_LIMIT_INCREASE_ID];
        this.documentType = jsonResponse[JSON_KEY_DOCUMENT_TYPE];
        this.documentTypeDisplay = jsonResponse[JSON_KEY_DOCUMENT_TYPE_DISPLAY];
        this.metaDataId = jsonResponse[JSON_KEY_META_DATA_ID];
    }


    static toJson(document) {
        let jsonObject = {};
        jsonObject[JSON_KEY_DOCUMENT_TYPE] = document.documentType;
        jsonObject[JSON_KEY_META_DATA_ID] = document.metaDataId;
        return jsonObject;
    }
}
